import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import {
  ListwidJson,
  UserModel,
  Chartgoogle,
  datawidget,
} from 'src/app/models/auth/_models/user.model';
import { MicroApplication } from 'src/app/services/microapplications/_models/microapplication.model';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { MessagesService } from 'src/app/services/service.index';
import { ChartType, GoogleChartsModule } from 'angular-google-charts';
import { Location } from '@angular/common'
import { v4 as uuid } from "uuid";
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-widget-preview',
  templateUrl: './widget-preview.html',
  styleUrls: ['./widget-preview.css'],
})
export class widgetpreviewcomponent implements OnInit {
  formId = uuid();
  public sessionData = JSON.parse(
    sessionStorage.getItem('sessionData') || '{}'
  );fv
  @Input() widget: MicroApplication;
  listalert: ListwidJson[] = [];
  saveButtonOptions: any;
  widgetApploaded:datawidget = new datawidget();
  microApploaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  widgetdata: datawidget = new datawidget();
  chartgoogle: Chartgoogle[] = [];
  url: BehaviorSubject<SafeResourceUrl> = new BehaviorSubject<SafeResourceUrl>(
    ''
  );
  urlObserver$: Observable<SafeResourceUrl>;
  style: string;
  data: any;
  columnNames = ['Browser', 'Percentage'];
  options = {};
  width = 550;
  height = 400;
  keyValueArray: [string, string][];
  dataA: any;
  user$: Observable<UserModel>;
  conpany: string;
  datg: any;
  editMode = false;
  fgt: { key: string; value: unknown[] }[];
  jsonObject: any;
  backOptions: any;
  insertMode = false;
  title: any;
    type: ChartType;
  user_code: any;
  constructor(
    private auth: AuthService,
    private _messagesService: MessagesService,
    public microApps: MicroapplicationService
  ) {
    this.urlObserver$ = this.url.asObservable();


  }

  ngOnInit(): void {
    this.user$ = this.auth.currentUserSubject.asObservable();
    this.conpany = this.sessionData.selectedCompany.code;
    this.user_code = this.sessionData.session.accountCod;
    this.datawidget( this.conpany);
  }

  datawidget(conpany:string) {
    this.microApps.WidgetsList(conpany, this.user_code).subscribe((resp) => {
      if (resp.isSuccessful) {
  
        this.chartgoogle = [];
for (const item of resp.result) {

  const type =
    item.wid_tiwd === 'T'
      ? ChartType.Table
      : ChartType.PieChart;

  this.chartgoogle.push({
    data: item.json,
    type,
    columnNames: item.columnnames,
    title: item.wid_desc,
    height: 550,
    width: 400,
  });
}

      } else {
        this._messagesService.error(resp.errorMessage);
      }
    });
  }
}
